/* eslint-disable import/no-anonymous-default-export */
export default {
  logo: "/assests/images/logo.png",
  bigLogo: "/assests/images/bigLogo.png",
  bannerImg: "/assests/images/bannerImg.png",
  arrowIcon: "/assests/images/gravity-ui-arrow-up.svg",
  FooterLineImage: "/assests/images/FooterLineImage.png",
  viewSectionImg: "/assests/images/viewSectionImg.png",
  DesignFutureSecBg: "/assests/images/DesignFutureSecBg.png",
  innerbanner01: "/assests/images/innerbanner01.png",
  cardImg01: "/assests/images/cardImg01.png",
  cardImg02: "/assests/images/cardImg01.png",
  cardImg03: "/assests/images/cardImg01.png",
  cardImg04: "/assests/images/cardImg01.png",
  CardsImg01: "/assests/images/CardsImg01.png",
  overbgImg01: "/assests/images/overbgImg01.png",
  serviceBanner: "/assests/images/serviceBanner.png",
  Frameoverlay: "/assests/images/Frameoverlay.png",
  Frameoverlay01: "/assests/images/Frameoverlay01.png",
  Frameoverlay02: "/assests/images/Frameoverlay02.png",
  Frameoverlay03: "/assests/images/Frameoverlay03.png",
  testimonialbg: "/assests/images/testimonialbg.png",
  avatarImg01: "/assests/images/avatarImg01.png",
  smallCard01: "/assests/images/smallCard01.png",
  smallCard02: "/assests/images/smallCard02.png",
  smallCard03: "/assests/images/smallCard03.png",
  testimonialOverlay: "/assests/images/testimonialOverlay.svg",
  carrerBg: "/assests/images/carrerBg.png",
  bgImg01: "/assests/images/bgImg01.png",
  careerbg01: "/assests/images/careerbg01.png",
  careerbg02: "/assests/images/careerbg02.png",
  careerbg03: "/assests/images/careerbg03.png",
  careerbg04: "/assests/images/careerbg04.png",
  videobg: "/assests/images/videobg.png",
  collboration: "/assests/images/collboration.png",
  contactBG: "/assests/images/contactBG.png",
  facebook: "/assests/images/facebook.png",
  linkdin: "/assests/images/linkdin.png",
  youtube: "/assests/images/youtube.png",
  instagram: "/assests/images/instagram.png",
  services_tabImg: "/assests/images/services_tabImg.png",
  ListCheckIcon: "/assests/images/ListCheckIcon.svg",
  facebook01: "/assests/images/facebook01.png",
  youtube01: "/assests/images/youtube01.png ",
  instagram01: "/assests/images/instagram01.png ",
  spotify01: "/assests/images/spotify01.png ",
  linkdin01: "/assests/images/linkdin01.png",
};
